module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "table-body"
  }, [_c('hr'), _c('div', {
    staticClass: "table-row table-padding"
  }, [_vm._m(0), _c('div', {
    staticClass: "table-col title"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('integrations.title.vtiger')))]), _c('div', {
    staticClass: "light-gray-text"
  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.vtiger')))])]), _c('div', {
    staticClass: "table-col table-col-collapsed actions"
  }, [_c('button', {
    staticClass: "btn btn-clean btn-config",
    on: {
      "click": function($event) {
        return _vm.open()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.configure')))])])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "form"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "id": "closeFormButton",
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _c('div', {
    staticClass: "info info-crm"
  }), _c('div', {
    staticClass: "row vertical-aligned"
  }, [_c('div', {
    staticClass: "form-group col-md-12",
    class: {
      'has-error': _vm.errors.has('access_key')
    }
  }, [_c('label', {
    attrs: {
      "for": "access_key"
    }
  }, [_vm._v(_vm._s(_vm.$t('integrations.attributes.accessKey')))]), _c('br'), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.setting.access_key),
      expression: "setting.access_key"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "access_key",
      "type": "text",
      "placeholder": _vm.$t('integrations.label.vtiger.accessKey')
    },
    domProps: {
      "value": (_vm.setting.access_key)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.setting, "access_key", $event.target.value)
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('access_key')),
      expression: "errors.has('access_key')"
    }],
    key: "access_key",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('access_key')))])])], 1)]), _c('br'), _c('div', {
    staticClass: "row vertical-aligned"
  }, [_c('div', {
    staticClass: "form-group col-md-6",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v(_vm._s(_vm.$t('integrations.attributes.email')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.setting.username),
      expression: "setting.username"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control bcc-input",
    attrs: {
      "name": "email",
      "type": "text",
      "placeholder": _vm.$t('integrations.label.vtiger.email')
    },
    domProps: {
      "value": (_vm.setting.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.setting, "username", $event.target.value)
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    key: "email",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])])], 1), _c('div', {
    staticClass: "form-group col-md-6",
    class: {
      'has-error': _vm.errors.has('url')
    }
  }, [_c('label', {
    attrs: {
      "for": "url"
    }
  }, [_vm._v(_vm._s(_vm.$t('integrations.attributes.apiUrl')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.setting.url),
      expression: "setting.url"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|url'),
      expression: "'required|url'"
    }],
    staticClass: "form-control bcc-input",
    attrs: {
      "name": "url",
      "type": "text",
      "placeholder": _vm.$t('integrations.label.vtiger.apiUrl')
    },
    domProps: {
      "value": (_vm.setting.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.setting, "url", $event.target.value)
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('url')),
      expression: "errors.has('url')"
    }],
    key: "url",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('url')))])])], 1)]), _c('hr', {
    staticClass: "lines-div"
  }), _c('span', [_c('div', {
    staticClass: "row vertical-aligned"
  }, [_c('div', {
    staticClass: "form-group col-md-7"
  }, [_c('trigger-stages', {
    attrs: {
      "integration": "vtiger",
      "settings": _vm.setting.triggers
    },
    on: {
      "selected-stages": _vm.setStages
    }
  })], 1), _c('div', {
    staticClass: "form-group col-md-5"
  }, [_c('div', {
    staticClass: "row description"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('integrations.label.vtiger.lead')) + ":")])])]), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('div', {
    staticClass: "row input-padding"
  }, [_c('div', {
    staticClass: "checkbox-inline",
    on: {
      "click": function($event) {
        return _vm.sending_checked('lead')
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.lead
    }
  }), _c('label', [_vm._v(_vm._s(_vm.$t('integrations.attributes.lead')))])])]), _c('div', {
    staticClass: "row input-padding"
  }, [_c('div', {
    staticClass: "checkbox-inline",
    on: {
      "click": function($event) {
        return _vm.sending_checked('contact')
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.contact
    }
  }), _c('label', [_vm._v(_vm._s(_vm.$t('integrations.attributes.contact')))])])])])])])])]), _c('div', {
    staticClass: "row vertical-aligned"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), _c('button', {
    staticClass: "pull-right btn btn-primary",
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.save')))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-col table-col-collapsed"
  }, [_c('div', {
    staticClass: "logo-box"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/vtiger.png"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2d6fb684!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/configuration/integrations/vtiger.vue
// module id = 1061
// module chunks = 1